module.exports = __webpack_public_path__ + "static/media/email.a73f1d26.png";